import { render, staticRenderFns } from "./UserLogoff.vue?vue&type=template&id=49894cb8&scoped=true&"
import script from "./UserLogoff.vue?vue&type=script&lang=js&"
export * from "./UserLogoff.vue?vue&type=script&lang=js&"
import style0 from "./UserLogoff.vue?vue&type=style&index=0&id=49894cb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49894cb8",
  null
  
)

export default component.exports